<ngx-l2-minimal-menu-bar>
  <ngx-heka-empty-page-container class="m-auto" [title]="'SANCTIONS_LIST.NO_ACCESS.TITLE'|translate"
                          [text]="'SANCTIONS_LIST.NO_ACCESS.DESCRIPTION'|translate">
    <ng-container image>
      <img src="assets/images/l2-illus/woman-add.svg">
    </ng-container>
    <ng-container actions>
      @if(!!lastActiveDomainId) {
        <button mat-flat-button color="primary" (click)="switchLastActiveDomain()">{{'SANCTIONS_LIST.NO_ACCESS.ACTION' |
          translate}}</button>
      }
    </ng-container>
  </ngx-heka-empty-page-container>
</ngx-l2-minimal-menu-bar>
